import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false
});

export function audienceReducer(state = initialState, action) {
  // console.log('in audiences reduecer....', action)
  switch (action.type) {
    case actionTypes.FETCH_AUDIENCES:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_AUDIENCES_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false
      }
    default:
      return state;
  }
}